/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiSanctionAlert } from './ApiSanctionAlert';
import {
    ApiSanctionAlertFromJSON,
    ApiSanctionAlertFromJSONTyped,
    ApiSanctionAlertToJSON,
    ApiSanctionAlertToJSONTyped,
} from './ApiSanctionAlert';

/**
 * 
 * @export
 * @interface SanctionAlertsPage
 */
export interface SanctionAlertsPage {
    /**
     * 
     * @type {number}
     * @memberof SanctionAlertsPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof SanctionAlertsPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof SanctionAlertsPage
     */
    total: number;
    /**
     * 
     * @type {Array<ApiSanctionAlert>}
     * @memberof SanctionAlertsPage
     */
    content: Array<ApiSanctionAlert>;
}

/**
 * Check if a given object implements the SanctionAlertsPage interface.
 */
export function instanceOfSanctionAlertsPage(value: object): value is SanctionAlertsPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function SanctionAlertsPageFromJSON(json: any): SanctionAlertsPage {
    return SanctionAlertsPageFromJSONTyped(json, false);
}

export function SanctionAlertsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SanctionAlertsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(ApiSanctionAlertFromJSON)),
    };
}

export function SanctionAlertsPageToJSON(json: any): SanctionAlertsPage {
    return SanctionAlertsPageToJSONTyped(json, false);
}

export function SanctionAlertsPageToJSONTyped(value?: SanctionAlertsPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(ApiSanctionAlertToJSON)),
    };
}

